module.exports = __webpack_public_path__ + "img/2.54a304b1.jpg";